(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-collection"] && !Shopify.designMode) return;
  try {
    
  // GUI-138 — Flickity marks the cells outside the viewport `aria-hidden`, but
  // leaves the links inside them in the tab order. So a keyboard user tabs into
  // products that screen readers have been told are not there, and the focus
  // ring vanishes off-screen. axe calls it aria-hidden-focus, and rates it
  // serious.
  //
  // Flickity rewrites the attribute on every slide change, so this watches for
  // that rather than running once, and mirrors `tabindex` to match: -1 while the
  // cell is hidden, restored when it comes back.
  (function () {
    var HIDDEN = 'aria-hidden';
    var STASH = 'data-a11y-prev-tabindex';

    function sync(cell) {
      var hidden = cell.getAttribute(HIDDEN) === 'true';
      var focusable = cell.querySelectorAll('a[href], button, input, select, textarea, [tabindex]');

      Array.prototype.forEach.call(focusable, function (el) {
        if (hidden) {
          if (!el.hasAttribute(STASH)) {
            el.setAttribute(STASH, el.getAttribute('tabindex') || '');
          }
          el.setAttribute('tabindex', '-1');
        } else if (el.hasAttribute(STASH)) {
          var previous = el.getAttribute(STASH);
          if (previous) {
            el.setAttribute('tabindex', previous);
          } else {
            el.removeAttribute('tabindex');
          }
          el.removeAttribute(STASH);
        }
      });
    }

    function watch(slider) {
      var cells = slider.querySelectorAll('.flickity-cell');
      if (!cells.length) return;

      Array.prototype.forEach.call(cells, sync);

      new MutationObserver(function (records) {
        records.forEach(function (record) {
          if (record.attributeName === HIDDEN) sync(record.target);
        });
      }).observe(slider, { attributes: true, attributeFilter: [HIDDEN], subtree: true });
    }

    function init() {
      var sliders = document.querySelectorAll('.section-collection .flickity-slider');
      Array.prototype.forEach.call(sliders, watch);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // Flickity initialises after the theme's own scripts, so the slider may not
    // exist yet on first paint. One deferred pass covers that without polling.
    setTimeout(init, 1200);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-video"] && !Shopify.designMode) return;
  try {
    
  // GUI-136 — the hero film is an enhancement, so it is delivered rather than
  // assumed. Four conditions must all hold before the source is attached at all;
  // otherwise the visitor keeps the poster and the browser never requests 7 MB.
  (function () {
    var DESKTOP_QUERY = '(min-width: 768px)';

    function shouldAttach() {
      if (!window.matchMedia) return false;
      if (!window.matchMedia(DESKTOP_QUERY).matches) return false;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;

      var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (connection && connection.saveData) return false;

      return true;
    }

    function setupToggle(video, toggle) {
      if (!toggle) return;

      var labelPause = toggle.getAttribute('data-label-pause');
      var labelPlay = toggle.getAttribute('data-label-play');

      function render() {
        var paused = video.paused;
        toggle.classList.toggle('is-paused', paused);
        toggle.setAttribute('aria-pressed', paused ? 'false' : 'true');
        toggle.setAttribute('aria-label', paused ? labelPlay : labelPause);
      }

      toggle.addEventListener('click', function () {
        if (video.paused) {
          var resumed = video.play();
          if (resumed && resumed.catch) resumed.catch(function () {});
        } else {
          video.pause();
        }
      });

      video.addEventListener('play', render);
      video.addEventListener('pause', render);

      toggle.removeAttribute('hidden');
      render();
    }

    function attach(video, toggle) {
      var src = video.getAttribute('data-hero-video-src');
      if (!src || video.getAttribute('src')) return;

      video.setAttribute('src', src);
      video.load();

      var started = video.play();
      if (started && started.then) {
        // A refused play() is survivable — the poster is a complete hero. Only
        // show the control once there is genuinely something playing to pause.
        started
          .then(function () {
            setupToggle(video, toggle);
          })
          .catch(function () {});
      } else {
        setupToggle(video, toggle);
      }
    }

    function init() {
      var videos = document.querySelectorAll('[data-hero-video]');
      if (!videos.length || !shouldAttach()) return;

      Array.prototype.forEach.call(videos, function (video) {
        var wrapper = video.parentNode;
        var toggle = wrapper ? wrapper.querySelector('[data-hero-video-toggle]') : null;
        var gate = document.getElementById('age-gate');

        // Test the gate's state rather than trusting the event: both scripts are
        // deferred and their order is not guaranteed, so a returning visitor's
        // `mg:age-verified` can fire before this listener exists.
        if (!gate || gate.hasAttribute('hidden')) {
          attach(video, toggle);
        } else {
          document.addEventListener(
            'mg:age-verified',
            function () {
              attach(video, toggle);
            },
            { once: true },
          );
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
